import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import UIPurchaseMotionButton from 'ui-addon-upgrades/button/UIPurchaseMotionButton';

const AssignSeatPanel = ({
  purchaseMotions,
  upgradeData
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'ebxInterstitialPage.assignSeat.assignSeatText',
        options: {
          productName: I18n.text(`upgrades.products.${upgradeData.apiName}`)
        }
      })
    }), purchaseMotions.map((purchaseMotion, i) => /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      use: "primary",
      purchaseMotions: purchaseMotions,
      level: i + 1,
      upgradeData: upgradeData,
      location: MERCH_CARD,
      style: {
        width: '100%',
        maxWidth: '300px'
      }
    }, purchaseMotion))]
  });
};

export default AssignSeatPanel;